<template>
  <app-modal :modal-id="modalId"
             :modal-title="modalTitle"
             ok-button-title="Renew"
             @confirm="dateSelected" @cancel="cancel">
    <template>
      <div class="row container-margin-bottom" id="show-selected-members">
        <div class="col-12" v-if="memberIds.length === 1">
          Set the expiration date for <strong>{{ memberIds[0] }}</strong>
        </div>
        <div class="col-12" v-else>
          Set an expiration date for following members:
          <div class="row row-indent scroll-container">
            <div v-for="(memberId) in memberIds" :key="memberId"
                 class="col-6 col-lg-4">
              {{ memberId }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group id="fg-member-renew-date_picker"
                        horizontal
                        :label-cols="5"
                        breakpoint="md"
                        label="Choose expiration date:"
                        :description="'Min expire date: ' + formattedMinExpirationString()">
            <date-picker id="member-renew-date_picker"
                         v-model="selectedExpirationDate"
                         :disabled-dates="disabledDates()"
                         :format="dateFormatter"
                         placeholder="Choose a date"
                         :bootstrap-styling="true"
                         :typeable="true"
                         @selected="validateSelectedDate"
                         @cleared="isValid=true">
            </date-picker>
            <span v-if="!isValid" class="inline-error-message">Date provided is invalid</span>
          </b-form-group>
        </div>
      </div>
    </template>
  </app-modal>
</template>

<script>
/* NOTE: See choose-expiration-mixin.js for most of the common Expiration attributes/options */
import * as moment from 'moment';
import expiration from '../../util/choose-expiration-mixin';

export default {
  name: 'MemberRenewModal',
  mixins: [expiration],
  props: {
    modalId: {
      type: String,
      required: true,
    },
    memberIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      modalTitle: 'Choose Expiration Date',
      /* The callback event that will be emitted when 'Confirm' is selected. */
      emittedEvent: 'memberExpirationSelected',
    };
  },
  methods: {
    emitConfirmedEvent(selectedDate) {
      this.$emit(this.emittedEvent, selectedDate);
    },
    disabledDates() {
      return {
        // Disable dates up to today, inclusively
        to: moment().toDate(),
        // Disable all dates after specific date
      };
    },
    isValidRenewalDate(date) {
      return moment(date).isSameOrAfter(this.minExpireDate());
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modals/MemberRenewModal.vue